/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ReferralRefEnum.
* @enum {}
* @readonly
*/
export default class ReferralRefEnum {
    
        /**
         * value: "regular"
         * @const
         */
        "regular" = "regular";

    
        /**
         * value: "email_gift"
         * @const
         */
        "email_gift" = "email_gift";

    

    /**
    * Returns a <code>ReferralRefEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ReferralRefEnum} The enum <code>ReferralRefEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

